import { StatusChip } from '@/design';

/**
 * "Unverified" — no number of this participant carries a `verified_at` — as every screen that
 * names a participant draws it: the person hub, a People row's chip for a participant with no
 * registry number to chip (each number's own chip says it otherwise), a registration run, and
 * the SEC ADV firm card's participants.
 *
 * **Muted, not an alarm.** It is the normal state: every migrated participant is unverified,
 * and so is much of what registration makes — every FSP registrant's, NIPR being a stub. A
 * loud badge on nearly every row would teach a reader to stop reading it. The loud one on these
 * screens is "Denied" — an owner said a number is not theirs, which is a queue — and the two must
 * not look alike: this is the design system's `neutral` chip, that one its `danger`.
 */
export function UnverifiedBadge({ className }: { className?: string }) {
  return (
    <StatusChip tone="neutral" className={className}>
      Unverified
    </StatusChip>
  );
}
